import React from 'react';
import PropTypes from 'prop-types';

const ViewTable = ({
  columns = [],
  data = [],
  title = '',
  mergeColumn = '',
  emptyText = 'No data available',
  showSerial = true,
  footer = null,
  headerStyle = {},
  cellStyle = {},
}) => {
  const thStyle = {
    padding: '10px 14px',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    color: '#fff',
    background: '#1f2937',
    whiteSpace: 'nowrap',
    borderRight: '1px solid #1f2937',
  };

  const tdStyle = (isAlt) => ({
    padding: '9px 14px',
    fontSize: '12.5px',
    color: '#1f2937',
    borderRight: '1px solid #e5e7eb',
    borderBottom: '1px solid #e5e7eb',
    background: isAlt ? '#f8faff' : '#fff',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  });

  return (
    <div style={{ marginBottom: '20px' }}>
      {title && (
        <div
          style={{
            fontSize: '12px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: '#1e40af',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              display: 'inline-block',
              width: '3px',
              height: '14px',
              background: '#1e40af',
              borderRadius: '2px',
            }}
          />
          {title}
        </div>
      )}

      <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #dde6f7' }}>
        <table style={{ borderCollapse: 'collapse', tableLayout: 'auto', width: '100%' }}>
          <thead>
            <tr>
              {showSerial && (
                <th
                  style={{
                    ...thStyle,
                    textAlign: 'center',
                    borderRight: '1px solid #1f2937',
                    ...headerStyle,
                  }}
                >
                  Sl.No
                </th>
              )}
              {columns.map((col, i) => (
                <th
                  key={col.key}
                  style={{
                    ...thStyle,
                    textAlign: col.align || 'left',
                    borderRight: i === columns.length - 1 ? 'none' : '1px solid #1f2937',
                    ...headerStyle,
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
            {/* <tr>
              <th style={{ ...thStyle, textAlign: 'center', borderRight: '1px solid #1f2937' }}>
                Sl.No
              </th>
              {columns.map((col, i) => (
                <th
                  key={col.key}
                  style={{
                    ...thStyle,
                    textAlign: col.align || 'left',
                    borderRight: i === columns.length - 1 ? 'none' : '1px solid #1f2937',
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr> */}
          </thead>

          {/* <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length + 1}
                  style={{
                    textAlign: 'center',
                    padding: '28px',
                    color: '#9ca3af',
                    fontSize: '13px',
                    fontStyle: 'italic',
                    background: '#fff',
                  }}
                >
                  {emptyText}
                </td>
              </tr>
            ) : (
              data.map((row) => {
                const rowKey = row.id ?? row.description ?? row[columns[0]?.key] ?? Math.random();
                const isAlt = data.indexOf(row) % 2 === 1;
                return (
                  <tr key={rowKey}>
                    <td
                      style={{
                        ...tdStyle(isAlt),
                        textAlign: 'center',
                        fontWeight: 600,
                        color: '#6b7280',
                      }}
                    >
                      {data.indexOf(row) + 1}
                    </td>
                    {columns.map((col, colIndex) => {
                      const cellValue = row[col.key];
                      return (
                        <td
                          key={col.key}
                          style={{
                            ...tdStyle(isAlt),
                            textAlign: col.align || 'left',
                            whiteSpace: col.wrap ? 'normal' : 'nowrap',
                            borderRight:
                              colIndex === columns.length - 1 ? 'none' : '1px solid #e5e7eb',
                          }}
                        >
                          {col.render ? (
                            col.render(cellValue, row)
                          ) : cellValue !== undefined && cellValue !== null && cellValue !== '' ? (
                            cellValue
                          ) : (
                            <span style={{ color: '#d1d5db' }}>—</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody> */}
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + 1} style={{ textAlign: 'center', padding: '28px' }}>
                  {emptyText}
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => {
                const isAlt = rowIndex % 2 === 1;

                return (
                  <tr>
                    {/* S.NO */}
                    {/* <td style={{ ...tdStyle(isAlt), textAlign: 'center' }}>{rowIndex + 1}</td> */}
                    {showSerial && (
                      <td style={{ ...tdStyle(isAlt), textAlign: 'center' }}>{rowIndex + 1}</td>
                    )}

                    {columns.map((col) => {
                      const cellValue = row[col.key];

                      // 🔥 MERGE LOGIC
                      if (mergeColumn && col.key === mergeColumn) {
                        // show only first row
                        if (rowIndex === 0) {
                          return (
                            <td
                              key={col.key}
                              rowSpan={data.length}
                              style={{
                                ...tdStyle(false),
                                textAlign: 'center',
                                fontWeight: 600,
                                verticalAlign: 'middle',
                              }}
                            >
                              {cellValue}
                            </td>
                          );
                        }
                        return null; // skip other rows
                      }

                      return (
                        <td
                          key={col.key}
                          style={{
                            ...tdStyle(isAlt),
                            textAlign: col.align || 'left',
                            ...cellStyle,
                          }}
                        >
                          {col.render ? (
                            col.render(cellValue, row)
                          ) : cellValue !== undefined && cellValue !== null && cellValue !== '' ? (
                            cellValue
                          ) : (
                            <span style={{ color: '#d1d5db' }}>—</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
          {footer && (
            <tfoot>
              <tr>
                {showSerial && <td style={{ ...tdStyle(false), background: '#fff6d6' }} />}
                {columns.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      ...tdStyle(false),
                      background: '#fff6d6',
                      fontWeight: 700,
                      textAlign: col.align || 'left',
                      ...(footer.styles?.[col.key] || {}),
                    }}
                  >
                    {footer.values?.[col.key] ?? ''}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

ViewTable.propTypes = {
  showSerial: PropTypes.bool,
  footer: PropTypes.shape({
    values: PropTypes.shape({}),
    styles: PropTypes.shape({}),
  }),
  headerStyle: PropTypes.shape({}),
  cellStyle: PropTypes.shape({}),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'center', 'right']),
      wrap: PropTypes.bool,
      render: PropTypes.func,
    }),
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  emptyText: PropTypes.string,
  mergeColumn: PropTypes.string,
};

export default ViewTable;
